import Request from "@/common/net/request.js";
const request = new Request();
// 获取列表
export function getPage(data) {
  return request.send({
    url: `/pmy/sys/sys/branch/page`,
    method: "post",
    data,
    config: {
      headers: {
        "Content-Type": "application/json"
      }
    }
  });
}
// 添加
export function addInfo(data) {
  return request.send({
    url: `/pmy/sys/sys/branch`,
    method: "post",
    data,
    config: {
      headers: {
        "Content-Type": "application/json"
      }
    }
  });
}

// 编辑
export function editInfo(data) {
  return request.send({
    url: `/pmy/sys/sys/branch`,
    method: "put",
    data,
    config: {
      headers: {
        "Content-Type": "application/json"
      }
    }
  });
}

// 删除
export function deleteInfo(supplierId) {
  return request.send({
    url: `/pmy/sys/sys/branch?companyId=${supplierId}`,
    method: "delete"
  });
}
// 重置密码
export function resetPassword(data) {
  return request.send({
    url: `/pmy/sys/sys/branch/pwd`,
    method: "put",
    data,
    config: {
      headers: {
        "Content-Type": "application/json"
      }
    }
  });
}
// 详情
export function detailInfo(supplierId) {
  return request.send({
    url: `/pmy/sys/sys/branch?companyId=${supplierId}`,
    method: "get"
  });
}

// 分公司下拉列表（用于下拉选择）
export function getBranchBaseList() {
  return request.send({
    url: `/pmy/sys/sys/branch/base/list`,
    method: "get"
  });
}

// 查询分公司权限
export function getPermission(companyId) {
  return request.send({
    url: `/pmy/sys/sys/branch/permission?companyId=${companyId}`,
    method: "get"
  });
}
// 配置分公司权限
export function setPermissions(data) {
  return request.send({
    url: `/pmy/sys/sys/branch/permissions`,
    method: "post",
    data,
    config: {
      headers: {
        "Content-Type": "application/json"
      }
    }
  });
}
